import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './OurLeaders.css';
import Heading from '../../../utls/Heading';
const OurLeaders = () => {
    return (
        <>
            <div className="our-leaders-section">
                <div className="our-leaders">
                    <Heading className='customheadings text-center text-uppercase text-white'>
                        <span className='last-banner-span'>Say hello  </span>to the leaders of our tribe!
                    </Heading>
                    <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
                        {/* <div className="carousel-indicators leader-indicators">
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
                            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
                        </div> */}
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <div className="container">
                                    <div className="row gap-3 gap-md-0">
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Pradeep%20Sir.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Pradeep Kishnani</p>
                                                    <p className='leader-designation mb-0'>Vice President & Partner</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>A driving force in shaping Blueberry Group's strategic vision.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Jai%20Sir.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Jai Kishan Tewani </p>
                                                    <p className='leader-designation mb-0'>Managing Director
                                                    </p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>A key architect of Blueberry Group's success and expansion.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Steve%20sir.jpg" className="d-block leader-img " alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Suresh(steve) Kirplani </p>
                                                    <p className='leader-designation mb-0'>Chairman</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Guiding Blueberry Group with experience and leadership.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gap-3 gap-md-0 ">
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/deepak%20sir.jpg" className="d-block leader-img " alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Deepak Tewani </p>
                                                    <p className='leader-designation mb-0'>Board Of Director</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Providing strategic, legal, and financial expertise to Blueberry Group.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Manoj%20Adwani.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Manoj Adwani</p>
                                                    <p className='leader-designation mb-0'>Board Of Director</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>A vital link in Blueberry Group's operational management.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Gaurav%20Makheeja.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Gaurav Makheeja </p>
                                                    <p className='leader-designation mb-0'>Board Of Director
                                                    </p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>A key player in Blueberry Group's regional growth and development.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gap-3 gap-md-0 ">
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Jiten%20Tolani.jpg" className="d-block leader-img " alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Jiten Tolani </p>
                                                    <p className='leader-designation mb-0'>Board Of Director</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Leading Blueberry Group's expansion into specialized travel experiences.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Jitendra%20Asrani.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Jitendra(Sunny) Asrani</p>
                                                    <p className='leader-designation mb-0'>Board Of Directors</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Contributing to Blueberry Group's regional market presence.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Kamal%20Manghnani.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Kamal Manghnani </p>
                                                    <p className='leader-designation mb-0'>Board Of Director
                                                    </p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Overseeing Blueberry Group's financial health and stability.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row gap-3 gap-md-0 ">
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Kishor%20Vatwani.jpg" className="d-block leader-img " alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Kishor Vatwani </p>
                                                    <p className='leader-designation mb-0'>Board Of Director</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>A key contributor to Blueberry Group's regional success.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Nikhil%20Golani.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Nikhil Golani</p>
                                                    <p className='leader-designation mb-0'>Board Of Directors</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Focusing on Blueberry Group's regional market development.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Prakash%20lalwani.jpg" className="d-block leader-img" alt="..." loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Prakash Lalwani </p>
                                                    <p className='leader-designation mb-0'>Board Of Director
                                                    </p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Driving Blueberry Group's regional business growth.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row justify-content-center ">
                                        <div className="col-md-6 col-lg-4 d-flex justify-content-center">
                                            <div className="leader-img-content text-white grotesk-headings text-center">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Ravi%20Sadhnani.jpg" className="d-block leader-img" alt="Kishor Vatwani" loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className="leader-name mb-0">Ravi Sadhnani</p>
                                                    <p className="leader-designation mb-0">Board Of Director</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className="leader-description text-start"> Playing a crucial role in Blueberry Group's regional operations.</p>
                                            </div>
                                        </div>

                                        {/* <div className="col-md-6 col-lg-4 d-flex justify-content-center">
                                            <div className="leader-img-content text-white grotesk-headings text-center">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/BBT%20BOD/Nikhil%20Golani.jpg" className="d-block leader-img" alt="Nikhil Golani" loading="lazy" />
                                                <div className="d-lg-flex justify-content-between mt-3">
                                                    <p className="leader-name mb-0">Nikhil Golani</p>
                                                    <p className="leader-designation mb-0">Board Of Directors</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className="leader-description">Innovative force behind Blueberry Group’s growth and development.</p>
                                            </div>
                                        </div> */}
                                    </div>

                                </div>
                            </div>
                            {/* <div className="carousel-item">
                            <div className="container">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/leader1.png" className="d-block leader-img " alt="..." />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Edwin Charles </p>
                                                    <p className='leader-designation mb-0'>CEO</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Leading the vision for global travel innovation.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/leader2.png" className="d-block leader-img" alt="..." />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Mellissa Adams</p>
                                                    <p className='leader-designation mb-0'>Head of Operations</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Ensuring seamless experiences for all our clients.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/leader3.png" className="d-block leader-img" alt="..." />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Ross Geller </p>
                                                    <p className='leader-designation mb-0'>President & Partner</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Ensuring seamless experiences for all our clients.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="carousel-item">
                            <div className="container">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/leader1.png" className="d-block leader-img " alt="..." />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Edwin Charles </p>
                                                    <p className='leader-designation mb-0'>CEO</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Leading the vision for global travel innovation.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/leader2.png" className="d-block leader-img" alt="..." />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Mellissa Adams</p>
                                                    <p className='leader-designation mb-0'>Head of Operations</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description'>Ensuring seamless experiences for all our clients.</p>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="leader-img-content text-white grotesk-headings">
                                                <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/leader3.png" className="d-block leader-img" alt="..." />
                                                <div className="d-flex justify-content-between mt-3">
                                                    <p className='leader-name mb-0'>Ross Geller </p>
                                                    <p className='leader-designation'>President & Partner</p>
                                                </div>
                                                <div className="border-lines"></div>
                                                <p className='leader-description mb-0'>Ensuring seamless experiences for all our clients.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default OurLeaders